/**
 * API Reference Introduction page content.
 *
 * Covers base URL, authentication, and API overview.
 */

export const apiIntroductionContent = `
Base URL: \`https://m8tes.ai/api/v2\`

All requests require an API key in the Authorization header. API keys use the \`m8_\` prefix.

\`\`\`
Authorization: Bearer m8_your_key_here
\`\`\`

\`\`\`python
from m8tes import M8tes

client = M8tes(api_key="m8_your_key_here")
# or set M8TES_API_KEY env var and call M8tes() with no args
\`\`\`

Get your API key from the [Developer dashboard](https://m8tes.ai/developer).

## Resources

The API is organized around these resources:

| Resource | Description |
|----------|-------------|
| [Teammates](/docs/api-reference) | Reusable personas with instructions and tools |
| [Runs](/docs/api-reference) | Task executions that stream Server-Sent Events |
| [Tasks](/docs/api-reference) | Reusable job definitions with triggers (schedule, webhook, email) |
| [Apps](/docs/api-reference) | Available tools and OAuth integrations |
| [Memories](/docs/api-reference) | End-user memory management |
| [Permissions](/docs/api-reference) | Tool allow-lists for end-users |
| [Webhooks](/docs/api-reference) | Event notification subscriptions |

All list endpoints use [cursor-based pagination](/docs/api-pagination). All errors follow a [standard format](/docs/api-errors).
`;
